import React, { useContext, useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Link } from "react-router-dom";
import images from "../../global-styles/images";
import { appLogger, Http } from "../../../src/utils";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { useNavigate } from "react-router-dom";
import ChangePasswordModal from "../../routes/home/ChangePasswordModal";
import LogoutIcon from "@mui/icons-material/Logout";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { AuthDetails, ROLE_USER_SUPERADMIN } from "../../model";
import { Grid, Typography } from "@mui/material";
import { roleConfig } from "../../utils/config/role-config";
interface EmployeeProps {
  userDetails: any;
}

function Header({ userDetails }: EmployeeProps) {
  const navigate = useNavigate();
  appLogger.info({
    infoObj: {
      method: "Header",
      component: "header",
      fileName: "index.tsx",
      userDetails: userDetails,
    },
  });
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [org, setOrg] = useState<string | undefined>("");
  const [orgByID, setOrgByID] = useState<any | undefined>(null);

  const userOrgId = localStorage.getItem("userOrgId");

  const {
    userInfo,
    setProVersion,
    setcontextRedirectProdPage,
    setBasicDetailAccordianContext,
    setGenSettingsAccordianContext,
    setFbSettingsAccordianContext,
    setBugSettingsAccordianContext,
    setFreqSettingsAccordianContext,
    setEmailSettingsAccordianContext,
    setExttrackingSettingsAccordianContext,
    setWidgAppSettingsAccordianContext,
    setWidgIntgSettingsAccordianContext,
    setQRSettingsAccordianContext,
    orgId,
    setOrgId,
  } = useContext(UserContext) as UserLoginInfo;
  const [orgResponse, setOrgResponse] = useState<any>("");
  const userRole = userInfo.userDetails
    ? userInfo.userDetails.userRole
      ? userInfo.userDetails.userRole.length > 0
        ? userInfo.userDetails.userRole
        : ""
      : ""
    : "";
  const { setIsAuthenticated, setUserInfo, setcontextProVersion } = useContext(
    UserContext
  ) as UserLoginInfo;

  const handleProfileMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleFetchEnabledFeatures = async (id: string) => {
    try {
      const res: any = await Http.get({
        url: `/api/v2/organizations/${id}`,
      });
      if (
        res?.organizationDetails &&
        res?.organizationDetails.enabledFeatures &&
        Object.keys(res?.organizationDetails.enabledFeatures).length > 0
      ) {
        const { enabledFeatures } = res?.organizationDetails;
        localStorage.setItem(
          "userenabledFeatures",
          JSON.stringify(enabledFeatures)
        );
      }
    } catch (err) {
      appLogger.error({
        errObj: {
          method: "handleFetchEnabledFeatures",
          component: "header",
          fileName: "basicDetails.tsx",
          err: err,
        },
      });
    }
  };

  const handleRole = (userDetails: any) => {
    for (const key in roleConfig) {
      if (userDetails.userRole == roleConfig[key]) {
        return key;
      }
    }
  };

  const handleUserOrgUpd = (orgId: string) => {
    if (userInfo && userInfo.userDetails && userInfo.userDetails.id) {
      Http.put({
        url: `/api/v2/users/`,
        body: {
          id: userInfo.userDetails.id,
          orgId: orgId,
        },
        state: userInfo,
      })
        .then((response) => {
          appLogger.info({
            infoObj: {
              method: "handleUserOrgUpd",
              component: "header",
              fileName: "index.tsx",
              userResponse: response,
            },
          });
          Http.get({
            url: `/api/v2/users/login`,
            // state: userStateVariable,
          })
            .then((response: any) => {
              if (response) {
                appLogger.info({
                  infoObj: {
                    method: "handleUserOrgUpd",
                    component: "header",
                    fileName: "index.tsx",
                    response: response,
                  },
                });
                response.userDetails.orgId = orgId;
                setcontextProVersion([]);
                setProVersion({
                  product: "",
                  version: "",
                });
                if (response.userDetails.userRole.length > 0) {
                  response.userDetails.userRole =
                    handleRole(response.userDetails) || "";
                }
                const obj: AuthDetails = {
                  isAuthenticated: true,
                  idToken: userInfo.idToken,
                  accessToken: userInfo.accessToken,
                  userDetails: response.userDetails,
                  isSsoUser: false,
                };
                setUserInfo(obj);
                if (
                  response &&
                  response.userDetails &&
                  response.userDetails &&
                  response.userDetails.orgId &&
                  response.userDetails.orgId != ""
                ) {
                  localStorage.setItem("userOrgId", response.userDetails.orgId);
                  handleFetchEnabledFeatures(response.userDetails.orgId);
                  navigate("/");
                }
              }
            })
            .catch((error: any) => {
              appLogger.error({
                errObj: {
                  method: "handleUserOrgUpd",
                  component: "header",
                  fileName: "index.tsx",
                  err: error,
                },
              });
            });
        })
        .catch((err) => {
          appLogger.error({
            errObj: {
              method: "handleUserOrgUpd",
              component: "header",
              fileName: "index.tsx",
              err: err,
            },
          });
        });
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };
  const selectOrg = (event: SelectChangeEvent) => {
    setOrgId((event.target as HTMLInputElement).value);
    handleUserOrgUpd(event.target.value);
  };
  const handleMenu = (type: any) => {
    setChangePasswordModal(true);
  };
  const closeChangePassModal = () => {
    setChangePasswordModal(false);
  };
  const logout = () => {
    localStorage.setItem("logoutEvent", Date.now().toString());
    localStorage.setItem("authToken", "");
    localStorage.setItem("user", "");
    localStorage.setItem("userenabledFeatures", "");
    localStorage.setItem("userOrgId", "");
    setUserInfo({
      isAuthenticated: false,
      idToken: "",
      accessToken: "",
      userDetails: null,
      isSsoUser: false,
    });
    setProVersion({
      product: "",
      version: "",
    });
    setcontextRedirectProdPage(false);
    setBasicDetailAccordianContext(true);
    setGenSettingsAccordianContext(false);
    setFbSettingsAccordianContext(false);
    setBugSettingsAccordianContext(false);
    setFreqSettingsAccordianContext(false);
    setEmailSettingsAccordianContext(false);
    setExttrackingSettingsAccordianContext(false);
    setWidgAppSettingsAccordianContext(false);
    setWidgIntgSettingsAccordianContext(false);
    setIsAuthenticated(false);
    setQRSettingsAccordianContext(false);
    navigate("/");

    // route("/"); // appends a history entry
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      sx={{ mt: "45px", textTransform: "capitalize" }}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      className="user-pro-menu"
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={() => handleMenu("change-password")}>
        <i className="icon-change-password" />
        &nbsp;change password
      </MenuItem>
      <MenuItem onClick={logout}>
        <LogoutIcon className="icon-change-password" />
        &nbsp;logout
      </MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  const renderOrgMenu = (
    <Box className="org-select">
      <FormControl className="custom-select" fullWidth>
        <InputLabel>Organization</InputLabel>
        <Select
          labelId="org-select"
          id="org-select"
          value={orgId}
          label="organization"
          onChange={selectOrg}
        >
          {orgResponse.length > 0 &&
            orgResponse.map((menu: any) => (
              <MenuItem key={menu.orgId} value={menu.orgId}>
                {menu.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );

  useEffect(() => {
    // if (
    //   userInfo &&
    //   userInfo.userDetails &&
    //   userInfo.userDetails.userRole === ROLE_USER_SUPERADMIN
    // ) {
    //   Http.get({
    //     url: `/api/v2/organizations/all`,
    //     state: userInfo,
    //   })
    //     .then((response: any) => {
    //       //sort organization by name
    //       response.organizationList.sort((a: any, b: any) => {
    //         if (a.name.toUpperCase() < b.name.toUpperCase()) {
    //           return -1;
    //         }
    //         if (a.name.toUpperCase() > b.name.toUpperCase()) {
    //           return 1;
    //         }
    //         return 0;
    //       });
    //       setOrgResponse(response.organizationList);
    //       if (userInfo && userInfo.userDetails && userInfo.userDetails.orgId) {
    //         const isOrgPresent = response.organizationList.find(
    //           (o: { orgId: string }) => {
    //             return (
    //               userInfo &&
    //               userInfo.userDetails &&
    //               userInfo.userDetails.orgId === o.orgId
    //             );
    //           }
    //         );
    //         appLogger.info(
    //           {
    //             infoObj: {
    //               method: "useEffect",
    //               component: "header",
    //               fileName: "index.tsx",
    //               isOrgPresent: isOrgPresent,
    //             },
    //           },
    //           "Organization present for the user"
    //         );
    //         if (isOrgPresent && Object.keys(isOrgPresent).length > 0) {
    //           setOrgId(userInfo.userDetails.orgId);
    //         } else if (response.organizationList.length > 0) {
    //           setOrgId(response.organizationList[0].orgId);
    //           handleUserOrgUpd(response.organizationList[0].orgId);
    //         }
    //       }
    //     })
    //     .catch((error) => {
    //       appLogger.error({
    //         errObj: {
    //           method: "useEffect",
    //           component: "header",
    //           fileName: "index.tsx",
    //           err: error,
    //         },
    //       });
    //     });
    // } else {
    //   if (userOrgId) {
    //     Http.get({
    //       url: `/api/v2/organizations/${userOrgId}`,
    //       state: userInfo,
    //     })
    //       .then((response: any) => {
    //         setOrgByID(response.organizationDetails);
    //       })
    //       .catch((error) => {
    //         appLogger.error({
    //           errObj: {
    //             method: "useEffect",
    //             component: "header",
    //             fileName: "index.tsx",
    //             err: error,
    //           },
    //         });
    //       });
    //   }
    // }

    if (userOrgId) {
      Http.get({
        url: `/api/v2/organizations/${userOrgId}`,
        state: userInfo,
      })
        .then((response: any) => {
          setOrgByID(response.organizationDetails);
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "useEffect",
              component: "header",
              fileName: "index.tsx",
              err: error,
            },
          });
        });
    } else {
      Http.get({
        url: `/api/v2/organizations/all`,
        state: userInfo,
      })
        .then((response: any) => {
          //sort organization by name
          response.organizationList.sort((a: any, b: any) => {
            if (a.name.toUpperCase() < b.name.toUpperCase()) {
              return -1;
            }
            if (a.name.toUpperCase() > b.name.toUpperCase()) {
              return 1;
            }
            return 0;
          });
          setOrgResponse(response.organizationList);
          if (userInfo && userInfo.userDetails && userInfo.userDetails.orgId) {
            const isOrgPresent = response.organizationList.find(
              (o: { orgId: string }) => {
                return (
                  userInfo &&
                  userInfo.userDetails &&
                  userInfo.userDetails.orgId === o.orgId
                );
              }
            );
            appLogger.info(
              {
                infoObj: {
                  method: "useEffect",
                  component: "header",
                  fileName: "index.tsx",
                  isOrgPresent: isOrgPresent,
                },
              },
              "Organization present for the user"
            );
            if (isOrgPresent && Object.keys(isOrgPresent).length > 0) {
              setOrgId(userInfo.userDetails.orgId);
            } else if (response.organizationList.length > 0) {
              setOrgId(response.organizationList[0].orgId);
              handleUserOrgUpd(response.organizationList[0].orgId);
            }
          }
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "useEffect",
              component: "header",
              fileName: "index.tsx",
              err: error,
            },
          });
        });
    }
  }, [userOrgId]);

  // useEffect(() => {
  //   if (orgId) {
  //     Http.get({
  //       url: `/api/v2/organizations/${orgId}`,
  //       state: userInfo,
  //     })
  //       .then((response: any) => {
  //         setOrgByID(response.organizationDetails);
  //       })
  //       .catch((error) => {
  //         appLogger.error({
  //           errObj: {
  //             method: "useEffect",
  //             component: "header",
  //             fileName: "index.tsx",
  //             err: error,
  //           },
  //         });
  //       });
  //   }
  // }, [orgId]);

  return (
    <React.Fragment>
      {/* <AppBar position="static" open={open}> */}

      <AppBar position="static">
        <Toolbar className="toolbar-wrap">
          <Link className="logo" to="/dashboard">
            <img src={images.logo} />
          </Link>
          {/* {userInfo &&
          userInfo.userDetails &&
          userInfo.userDetails.userRole === ROLE_USER_SUPERADMIN ? (
            renderOrgMenu
          ) : (
            <>
              <Box className="org-select">
                <Grid container sx={{ marginX: "40px" }}>
                  <Grid item xs={12}>
                    <Typography
                      sx={{ fontSize: "14px", fontWeight: 600, color: "white" }}
                    >
                      Organization
                    </Typography>
                    <Typography style={{ fontSize: "12px", color: "white" }}>
                      {orgByID?.name}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </>
          )} */}

          <Box className="org-select">
            <Grid container sx={{ marginX: "40px" }}>
              <Grid item xs={12}>
                <Typography
                  sx={{ fontSize: "14px", fontWeight: 600, color: "white" }}
                >
                  Organization
                </Typography>
                <Typography
                  title={orgByID?.name}
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "100px",
                    fontSize: "12px",
                    color: "white",
                  }}
                >
                  {orgByID?.name}
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <Box className="profile-menu">
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle className="profile-icon" />

              <Box component="div" className="profile-info">
                <h2>{userDetails.nameFirst}</h2>
                <span>{userRole}</span>
              </Box>
              <KeyboardArrowDownIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
      {changePasswordModal && (
        <ChangePasswordModal
          closeChangePassModal={closeChangePassModal}
          changePasswordModal={changePasswordModal}
        />
      )}
    </React.Fragment>
  );
}

export default Header;
